export default {
  measuringManager: {
    list: {
      title: "Measuring",
    },
    create: {
      success: "Add measuring success!",
      keyExisted: "Measuring code is existed!",
    },
    edit: {
      success: "Update measuring success!",
    },
    form: {
      key: {
        label: "Code",
        placeholder: "Input measuring code",
        error: "Please input measuring code!",
      },
      name: {
        label: "Name",
        placeholder: "Input measuring name",
        error: "Please input measuring name!",
      },
      unit: {
        label: "Unit",
        placeholder: "Input unit of measuring",
      },
      error: "Error!",
    },
  },
  stationTypeManager: {
    list: {
      title: "Station type",
    },
    create: {
      success: "Add station type success!",
      keyExisted: "Station type code is existed!",
    },
    edit: {
      success: "Update station type success!",
    },
    form: {
      key: {
        label: "Code",
        placeholder: "Input station type code",
        error: "Please input station type code!",
      },
      name: {
        label: "Name",
        placeholder: "Input station type name",
        error: "Please input station type name!",
      },
      icon: {
        label: "Icon",
      },
      auto: {
        label: "Auto",
      },
      error: "Error!",
    },
  },
  stationAutoManager: {
    list: {
      title: "Station auto",
    },
    create: {
      success: "Add station auto success!",
      keyExisted: "Station auto code is existed!",
    },
    edit: {
      success: "Update station auto success!",
    },
    form: {
      key: {
        label: "Code",
        placeholder: "Input station auto code",
        error: "Please input station auto code!",
      },
      name: {
        label: "Name",
        placeholder: "Input station auto name",
        error: "Please input station auto name!",
      },
      stationType: {
        label: "Type",
        placeholder: "Input type",
      },
      address: {
        label: "Address",
        placeholder: "Address",
      },
      long: {
        label: "Longitude",
        placeholder: "Input longitude",
        error: "Please input longitude",
      },
      lat: {
        label: "Latitude",
        placeholder: "Input latitude",
        error: "Please input latitude",
      },
      emails: {
        label: "Emails",
        placeholder: "Input emails",
        error: "Please input emails",
      },
      phones: {
        label: "Phones",
        placeholder: "Input phones",
        error: "Please input phones",
      },
      measuringKey: {
        label: "Measuring code",
        placeholder: "Input measuring code",
        error: "Please input measuring code",
      },
      measuringName: {
        label: "Measuring name",
        placeholder: "Input measuring name",
        error: "Please input measuring name",
      },
      measuringUnit: {
        label: "Unit",
        placeholder: "Input unit",
        error: "Please input unit",
      },
      measuringMinLimit: {
        label: "Min limit",
        placeholder: "Input min limit",
        error: "Please input min limit",
      },
      measuringMaxLimit: {
        label: "Max limit",
        placeholder: "Input max limit",
        error: "Please input max limit",
      },
      options: {
        isAllowWarning: "Allow Warning",
        isAllowRemote: "Allow Remote",
      },
      error: "Error!",
    },
  },
  dataSearchFrom: {
    form: {
      stationType: {
        label: "Station type",
        placeholder: "Select station type",
      },
      stationAuto: {
        label: "Station auto",
        placeholder: "Select station auto",
      },
      fromDate: {
        label: "From",
        placeholder: "Select from date",
      },
      toDate: {
        label: "To",
        placeholder: "Select to date",
      },
      measuringList: {
        label: "Measuring",
        placeholder: "Select measuring",
        require: "choose at least 1 measuring",
      },
      isExceeded: {
        label: "Is exceeded",
      },
      operator: {
        label: "Operator",
      },
      value: {
        label: "Value",
      },
      type: {
        label: "Report type",
      },
      advanced: {
        label: "Advanced",
      },
    },
  },
  avgSearchFrom: {
    form: {
      stationType: {
        label: "Station type",
        placeholder: "Select station type",
      },
      stationAuto: {
        label: "Station auto",
        placeholder: "Select station auto",
      },
      fromDate: {
        label: "From",
        placeholder: "Select from date",
      },
      toDate: {
        label: "To",
        placeholder: "Select to date",
      },
      measuringList: {
        label: "Measuring",
        placeholder: "Select measuring",
      },
      isExceeded: {
        label: "Is exceeded",
      },
      operator: {
        label: "Operator",
      },
      value: {
        label: "Value",
      },
      type: {
        label: "Report type",
      },
      advanced: {
        label: "Advanced",
      },
    },
    list: {
      receivedAt: {
        label: "Received at",
      },
    },
  },
  userSearchFrom: {
    form: {
      userName: {
        label: "Username",
        placeholder: "Username",
      },
      email: {
        label: "Email",
        placeholder: "Email",
      },
      firstName: {
        label: "FirstName",
        placeholder: "FirstName",
      },
      lastName: {
        label: "LastName",
        placeholder: "LastName",
      },
      country: {
        label: "Country",
        placeholder: "Select Country",
      },
      organization: {
        label: "Organization",
        placeholder: "Select Organization",
      },
      phone: {
        label: "Phone",
        placeholder: "Phone",
      },
    },
  },
  userForm: {
    form: {
      userName: {
        label: "Username",
        placeholder: "Username",
      },
      email: {
        label: "Email",
        placeholder: "Email",
      },
      password: {
        label: "Password",
        placeholder: "Password",
      },
      confirmPassword: {
        label: "Confirm Password",
        placeholder: "Confirm Password",
        message: "Please confirm your password!",
      },
      firstName: {
        label: "FirstName",
        placeholder: "FirstName",
      },
      lastName: {
        label: "LastName",
        placeholder: "LastName",
      },
      country: {
        label: "Country",
        placeholder: "Select Country",
      },
      organization: {
        label: "Organization",
        placeholder: "Select Organization",
      },
      phone: {
        label: "Phone",
        placeholder: "Phone",
      },
      isOwner: {
        label: "isOwner",
        placeholder: "isOwner",
      },
      isAdmin: {
        label: "isAdmin",
        placeholder: "isAdmin",
      },
    },
  },
  userManager: {
    list: {
      enableAccount: "Enable Account",
      disableAccount: "Disable Account",
      confirmEnableAccount: "Do You Want To {0} These Accounts?",
      enable: "Enable",
      disable: "Disable",
      deactivate: "Deactivate",
      action: "Action",
      email: "Email",
      country: "Country",
      login: "Login",
      status: "Status",
      roleAssign: "Assign Role",
      createdAt: "Created At",
      setPassword: "Set Password",
    },
  },
  organization: {
    form: {
      organizationType: {
        label: "Deployment Method",
      },
      status: {
        label: "Status",
        placeholder: 'Status',
        active: 'Active',
        aboutToExpired: 'About to expired',
        expired: 'Expired',
        unlimited: 'Unlimited',
      },
      email: {
        label: "Organization email",
        placeholder: "example@gmail.com",
      },
      name: {
        label: "name",
        placeholder: "name",
      },
      address: {
        label: 'address',
        cuong: 'address',
        placeholder: "address",
      },
      addressAPI: {
        label: "addressAPI",
        placeholder: "addressAPI",
      },
      databaseInfo: {
        name: {
          label: "Database name",
          placeholder: "Database name",
          message: "String must not contain special characters!!!",
        },
        address: {
          label: "Address",
          placeholder: "Address",
        },
        user: {
          label: "User",
          placeholder: "User",
        },
        pwd: {
          label: "Password",
          placeholder: "Password",
        },
        port: {
          label: "Port",
          placeholder: "Port",
        },
        confirmPassword: {
          label: "ConfirmPassword",
          placeholder: "ConfirmPassword",
          message: "Please confirm database password!",
        },
      },
      country: {
        label: "Country",
        placeholder: "Select Country",
      },
      organization: {
        label: "Organization",
        placeholder: "Select Organization",
      },
      phone: {
        label: "Phone",
        placeholder: "Phone",
      },
      totalStation: {
        label: "Station limit",
        placeholder: "Station limit",
        max: "Maximum of 500 stations",
      },
      totalUser: {
        label: "User limit",
        placeholder: "User limit",
        max: "Maximum of 500 Users",
      },
      expirationDate: {
        label: "Expiration date",
        placeholder: "Expiration date",
      },
      timeline: {
        label: {
          enabled: "Turn on the Timeline feature",
        },
        input: {
          label: {
            key: "API key",
            secret: "Secret key",
            appId: "App ID",
          },
        },
      },
      timeZone: {
        label: "TimeZone",
        placeholder: "Select TimeZone"
      },
      enableShareAPI: "Enable share API",
      apiKey: "API key",
      generateApiKey: "Generate API key",
      regenerateApiKey: "Regenerate API key",
    },
    rule: {
      label: "Rule",
      orderby: {
        label: "#",
        placeholder: "#",
      },
      menu: {
        label: "Module",
        placeholder: "Module",
      },
      action: {
        label: "Action",
        placeholder: "Action",
        package: "Package",
      },
      dashboard: {
        name: "Health check"
      },
      dashboard_2: {
        name: "Monitoring overview"
      },
      utilityDashboard:{
        name: 'Dashboard'
      },
      overview: {
        name: "Dashboard"
      },
      monitoring: {
        name: "Real-time Monitoring",
      },
      monitorByList: {
        name: "Monitor by list",
      },
      map: {
        name: "Map",
      },
      camera: {
        name: "Camera",
      },
      chart: {
        name: "Data Insights",
      },
      dataSearch: {
        name: "History Data",
      },
      avgSearch: {
        name: "Average Data",
      },
      xuLyDuLieu_config: {
        name: "Data Processing - Config",
      },
      kiemDuyetDuLieu: {
        name: "Check Data",
      },
      periodicalStation: {
        name: "Periodic Monitoring Station"
      },
      periodicalImportStation: {
        name: "Periodic Forecast Data Input"
      },
      periodicalSeachData: {
        name: "Periodic Forecast Data Lookup"
      },
      billingReport: {
        name: "Fee Reporting",
      },
      billingConfig: {
        name: "Fee Calculation Configuration",
      },
      incidentManagement: {
        name: 'Incident Management'
      },
      incidentConfigProperties: {
        name: 'Incident Attribute Configuration'
      },
      qaqcConfig: {
        name: "Sharing Configurations",
      },
      service_config: {
        name: "Service configuration",
      },
      ftpTransfer: {
        name: "FTP Transfer Configurations",
      },
      shareAPI: {
        name: "API Share",
      },
      tiLeDuLieuThuDuoc: {
        name: "Percentage of obtained data",
      },
      tiLeDuLieu: {
        name: "Percentage of data",
      },
      tb24H: {
        name: "24-hour average",
      },
      tb1H: {
        name: "1-hour average monitoring",
      },
      tb1HMax: {
        name: "Average maximum 1 hour",
      },
      tb8HMax: {
        name: "Average maximum 8 hour",
      },
      tileDuLieuVuotNguong: {
        name: "Percentage of exceeded data",
      },
      soLanMatKetNoi: {
        name: "Number of disconnections",
      },
      aqiReport: {
        name: "AQI Report",
      },
      wqiGio: {
        name: "WQI - Hour",
      },
      wqiNgay: {
        name: "WQI - Day",
      },
      wqiPeriodic: {
        name: "WQI - Periodic",
      },
      tinhTrangDuLieu: {
        name: "Status Data",
      },
      reportExceed: {
        name: "Report Exceed",
      },
      reportFlow: {
        name: "Report Flow",
      },
      aqiMap: {
        name: "AQI Map",
      },
      wqiMap: {
        name: "WQI Map",
      },
      configWQI: { name: "AQI & WQI Configurations" },
      stationFixPhase: {
        name:"Manage the monitoring phase"
      },
      stationFix: {
        name:"Monitoring point management"
      },
      stationFixInput: {
        name: "Monitoring data"
      },
      stationFixData: {
        name: "Look up monitoring point data"
      },
      stationFixMap: {
        name: "Monitoring point map"
      },
      stationAuto: {
        name: "Stations",
      },
      cauHinhKetNoi: {
        name: "Connection configuration",
      },
      cauHinhGuiCanhBao: {
        name: "Configure to Send Notifications",
      },
      cauHinhLayMau: {
        name: "Sampling configuration",
      },
      cauHinhTinhToanAQI: {
        name: "Configure AQI calculation",
      },
      cauHinhTinhToanWQI: {
        name: "Configure WQI calculation",
      },
      configCalculate: {
        name: "Calculation Configuration",
      },
      cauHinhCamera: {
        name: "Camera configuration",
      },
      measuring: { name: "Parameter" },
      stationType: { name: "Type of Station" },
      province: { name: "Site" },
      qcvn: { name: "Standard" },
      role: { name: "Role" },
      user: { name: "User" },
      config_color_noti: {
        name: "Configure warning color",
      },
      language:{
        name: "Language Configuration",
      },
      xem_Nhat_ky: {
        name: "View Diary",
      },
      connectionManagement: {
        name: 'Connection Management',
      },
      controlInterface: {
        name: 'Control Interface',
      },
      mobile_dashboard: {
        name: "Dashboard Mobile",
      },
      actions: {
        role: "Role Assignment",
        enableAccount: "Enable/Disable Account",
        config: "Config",
        download: "Download",
        import: "Import",
        wqi_export: "Export",
        aqi_export: "Export",
        isTransfer: "Edit Send FTP Station",
        updateFTP: "Edit Info FTP",
        publicStation: "Edit Publish Station",
        view: "Xem",
        camera: "Camera",
        control: "Sampling",
        chart: "Chart",
        map: "Map",
        images: "Images",
        infoStation: "Station Information	",
        reviewStation: "Review Station",
        create: "Create",
        edit: "Edit",
        delete: "Delete",
        export: "Export",
        setup: "Setup",
        manualapprove: "Manual Approve",
        unapprove: "Unapprove",
        approve: "Approve",
        restore: "Restore",
        remove: "Remove",
        statistics_device: "Statistics Device",
        statistics_exceeded_avgDay: "Exceeded Avg Day",
        pushDuLieu: "Push data",
        vuotNguongTBNgay: "Average daily exceed",
        bieuDoAQI: "AQI chart",
        bieuDoWQI: "WQI chart",
        bieuDoMatKetNoi: "Disconnections",
        bieuDoVuotNguong: "Exceeded",
        thongKeLoaiTram: "Statistics by station type",
        fTPFloder: "FTP Floder",
        fileMapping: "File Mapping",
        updateSelectStation: "Update selected stations",
        exceedDailyAvg: 'Exceed Daily Average',
        connect: 'Connect',
        linkBilling: 'Link Billing'
      },
      alarm_management: {
        name: "Setting Alarm"
      },
      alarm_history: {
        name: "Alarm History"
      },
      mapMonitor: {
        name: "AQI/WQI Map"
      },
      ticket: {
        name: "Incidents"
      },
      dataAnalytic: {
        name: "Data Analytics"
      },
      stationPeriodic: {
        name: "Periodic Monitoring"
      },
      connection: {
        name: "Connection"
      },
      report: {
        name: "Report"
      },
    },
    package: {
      label: "Package",
      totalUser: {
        label: "Total Users",
        message: "Please input total users",
      },
      totalStation: {
        label: "Total Stations",
        message: "Please input total station",
      },
      expiredAt: {
        label: "Expire At",
        message: "Please input expire at",
      },
      contractId: {
        label: "Number Contract",
        message: "Please input number contract",
      },
      contractStatus: {
        label: "Contract Status",
        message: "Please input contract status",
      },
      contractSignDate: {
        label: "Contract Signing Date",
        message: "Please input contract signing date",
      },
      contractExpiredDate: {
        label: "Expire Contract",
        message: "Please input expire contract",
      },
      productionDate: {
        label: "Product Delivery Date",
        message: "Please input product delivery date",
      },
      directSeller: {
        label: "Direct Seller",
        message: "Please input direct seller",
      },
      numberOfExpirationDate: {
        label: "Number of expiration dates",
        message: "Please select number of expiration dates",
        fiveDates: "5 dates",
        tenDates: "10 dates",
        fifteenDates: "15 dates",
        twiceDates: "20 dates",
      },
    },
    language: {
      action: 'Refresh Language'
    }
  },
  languageLocale: {
    list: {
      title: "Language locale",
    },
    form: {
      key: {
        label: "Code",
        placeholder: "Language locale code",
        error: "Please input language locale code!",
      },
      name: {
        label: "Name",
        placeholder: "Input station type name",
        error: "Please input station type name!",
      },
    },
  },
  addon: {
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    remove: "Remove",
    restore: "Restore",
    disable: "Disable",
    updateVersion: 'Version Update Notice',
    onSave: {
      add: {
        success: "Add success!",
        error: "Add error!",
      },
      update: {
        success: "Update success!",
        error: "Update error",
      },
    },
    onDelete: {
      success: "Delete success!",
      error: "Delete error!",
    },
    onDisable: {
      success: "Disable success!",
      error: "Disable error!",
    },
    onRestore: {
      success: "Restored Successfully",
      error: "Restore Error",
    },
    onRefreshLanguage: {
      success: "Refresh Language Successfully",
      error: 'Refresh Language Error',
    },
    search: "Search",
  },
  error: {
    reachedMaxUsers:
      "The maximum number of accounts for this organization is  <%=totalUser || 0 %>, you cannot transfer more users to this organization.",
      
  },
};



// WEBPACK FOOTER //
// ./src/languages/en.js